export default class StoreFromServer {
  constructor(name, interior, exterior) {
    this.name = name;
    this.interior = interior;
    this.exterior = exterior;
  }
}